import { Component, Inject, OnDestroy } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import { AuthorizedApiService } from '../../services/authorized-api.service';
import { Subscription } from 'rxjs';
import { MessengerService } from '../../services/messenger.service';
import { DialogButtonComponent } from "../buttons/dialog-button.component";
import { TranslateService } from '../../services/translate.service';
import { Translation } from '../../models/Translation';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
    standalone: true,
    imports: [DialogButtonComponent],
    template: `
    <div class="bg-theme-surface rounded-2xl shadow-xl max-w-2xl w-full">
      <div class="p-6 w-96 max-w-full">
        <h2 class="text-xl font-bold mb-4">{{ modalData?.title }}</h2>
        <p>{{ modalData?.message }}</p>
        <div class="mt-4 flex gap-2 justify-end">
          <app-dialog-button
            [text]="modalData?.abortText || 'Avbryt'"
            (onClick)="close(false)">
          </app-dialog-button>
          <app-dialog-button
            [text]="modalData?.confirmText || 'Ok'"
            [disabled]="isWorking"
            (onClick)="selectLang()"
            variant="primary">
          </app-dialog-button>
        </div>
      </div>
    </div>
  `
})
export class ConfirmLangDialogComponent implements OnDestroy {
    modalData?: {
        title: string;
        message: string;
        confirmText?: string;
        abortText?: string;
        action?: string;
        lang?: any;
    };

    private sub = new Subscription();
    isWorking = false;
    table: string;
    private venueId: any;
    lang: any;
    alert = "";

    constructor(
        private modalService: ModalService,
        @Inject('MODAL_DATA') public data: any,
        private api: AuthorizedApiService,
        private messengerService: MessengerService,
        private translate: TranslateService,
        private snackbarService: SnackbarService
    ) {
        this.modalData = data;
        this.table = data.table;
        this.venueId = data.venueId;
        this.lang = data.lang;
    }

    close(value: any = false): void {
        this.modalService.close(value);
    }

    ngOnInit(): void {
        this.isWorking = true;
        this.translate.observeAlert(this.lang.code).subscribe((res: Translation) => {
            this.isWorking = false;
            console.log("in observe", res);
            this.alert = res.translation;
        }, error => {
            this.isWorking = false;
            this.snackbarService.showMessage("Some error happened :(");
            //this.snackbar.open("Some error happened :(", null, { duration: 3000 });
        });
    }

    getString(s: string) {
        return this.translate.single(s);
    }

    selectLang(): void {
        this.isWorking = true;
        if (this.modalData?.action === 'confirm') {
            const sub = this.translate.prepareLangTranslation(this.lang.code).subscribe(res => {
                if (res) {
                    this.isWorking = false;
                    localStorage.setItem("collinsLang", this.lang.code);
                    window.location.reload();
                    this.close(true);
                }
                
            });
            this.sub.add(sub);
        } else {
            this.close(false);
        }
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }
}
